module.exports = __webpack_public_path__ + "img/setup.11b57cdb.png";